import { NotFound } from '@gravity-ui/illustrations';
import { Button, Link } from '@gravity-ui/uikit';

import { ADMINISTRATION, EMAIL, ERROR, REBOOT } from '../../constants';
import { handleReload } from '../reload-page';

import styles from './styles.module.scss';

export const ProfileError = () => {
	return (
		<div className={styles.profile_error}>
			<NotFound />
			<h3 className={styles.profile_error__title}>{ERROR}</h3>
			<p className={styles.profile_error__link}>
				{ADMINISTRATION}{' '}
				<Link view="normal" href="#">
					{EMAIL}
				</Link>
			</p>
			<Button size="l" onClick={handleReload}>
				{REBOOT}
			</Button>
		</div>
	);
};
